export type Recommendation = {
    customLabel?: string;
    content: {
        category?: string;
        main_category?: string;
        sub_category?: string;
        prod_category?: string;
        description?: string;
        company_name?: string;
        heading?: string;
        job_title?: string;
        published?: string;
        duration?: string;
        published_relative: string;
    };
    heading: string;
    image: {
        height: number;
        type: string;
        unscalable: boolean;
        url: string;
        width: number;
        isAbsolute: boolean;
    };
    itemId: string;
    label: string;
    location: {
        combined: string;
    };
    subheading: string;
    type: string;
    url: string;
    renderType?: string;
    overlay: {
        image: {
            isAbsolute: boolean;
            type: string;
            url: string;
        };
        p4p: {
            label: string;
        };
        minColumns?: number;
        cms: {
            label: string;
        };
        easyapply: {
            label: string;
        };
    }
    shippingOption: ShippingOption
    tracking: {
        ec: {
            click: Array<string>;
            inScreen: Array<string>;
        };
        action: {
            block: Array<string>;
        };
        pulse?: PulseRecommendation;
    };
    favourite: {
        itemId: string;
        itemType: string;
    };
};

export type ShippingOption = {
    label: string
};

export type Tag = {
    items: TagQueryItem[];
    fetchMore: [];
    size: number;
    version: string;
};

export type TagQueryItem = {
    itemId: string;
    type: string;
    renderType: string;
    score: number;
    version: string;
};

export enum FeedbackType {
    Forhandler = 'bap_forhandler_search',
    Keyword = 'keyword',
}

export type RecommendationsResponse = {
    fetchMore: string[];
    items: Recommendation[];
    size: number;
    uuid: string;
    version: string;
    'tracking-context': {};
};

export type PulseRecommendation = {
    [key: string]: [{}];
};

declare global {
    namespace JSX {
        interface IntrinsicElements {
            'recirc-native-ad': { props: string, class: string };
        }
    }
}
